"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const ai_1 = require("react-icons/ai");
const fa_1 = require("react-icons/fa");
const ShowTransactionModal_1 = __importDefault(require("../Modals/ShowTransactionModal"));
const TransactionsAdminTable = () => {
    const [page, setPage] = react_1.default.useState(1);
    const [perPage, setPerPage] = react_1.default.useState(5);
    const [showTransactionModal, setShowTransactionModal] = (0, react_1.useState)(false);
    const handleShowTransactionModal = () => {
        setShowTransactionModal(true);
    };
    const handleCloseTransactionModal = () => {
        setShowTransactionModal(false);
    };
    const statutFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "statutformatter__wrapper" }, (row === null || row === void 0 ? void 0 : row.statut) === "Délivrée" ? (react_1.default.createElement("div", { className: "badge custom-badge-success" }, row === null || row === void 0 ? void 0 : row.statut)) : (react_1.default.createElement("div", { className: "badge custom-badge-in-progress" }, row === null || row === void 0 ? void 0 : row.statut))));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement("div", { className: "container-btn-action-icon-modal d-flex justify-content-center" },
                react_1.default.createElement("button", { className: "btn btn-action-modal-icon with-tooltip", "data-tooltip-content": "Voir", onClick: handleShowTransactionModal },
                    react_1.default.createElement(ai_1.AiFillEye, null))),
            react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" } },
                react_1.default.createElement(fa_1.FaTrash, null))));
    };
    const columns = [
        {
            dataField: "date",
            text: "Date",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "montant",
            text: "Montant",
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "utilisateur",
            text: "Utilisateur",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "payment",
            text: "Méthode de paiement",
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "statut",
            text: "Statut",
            formatter: statutFormatter,
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "col-lg-12" },
            react_1.default.createElement("div", { className: "admin-table" },
                react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: data, columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table" }),
                react_1.default.createElement("div", { className: "custom-pagination-container" },
                    react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: data === null || data === void 0 ? void 0 : data.length, page: page, onChange: (page, perPage) => {
                            setPerPage(perPage);
                            setPage(page);
                        }, perPage: perPage })))),
        react_1.default.createElement(ShowTransactionModal_1.default, { show: showTransactionModal, handleClose: handleCloseTransactionModal })));
};
exports.default = TransactionsAdminTable;
const data = [
    {
        id: 1,
        utilisateur: "ama@gmail.com",
        date: "Mardi 23 Juin 2025",
        montant: "2000 FCFA",
        statut: "Délivrée",
        payment: "Wave",
    },
    {
        id: 2,
        utilisateur: "ama@gmail.com",
        date: "Mardi 23 Juin 2025",
        montant: "4000 FCFA",
        statut: "Délivrée",
        payment: "Orange Money",
    },
    {
        id: 3,
        utilisateur: "ama@gmail.com",
        date: "Mardi 23 Juin 2025",
        montant: "24 000 FCFA",
        statut: "Délivrée",
        payment: "Wave",
    },
    {
        id: 4,
        utilisateur: "ama@gmail.com",
        date: "Mardi 23 Juin 2025",
        montant: "2000 FCFA",
        statut: "En cours",
        payment: "Wave",
    },
    {
        id: 5,
        utilisateur: "ama@gmail.com",
        date: "Mardi 23 Juin 2025",
        montant: "2000 FCFA",
        statut: "Délivrée",
        payment: "Wave",
    },
    {
        id: 6,
        utilisateur: "ama@gmail.com",
        date: "Mardi 23 Juin 2025",
        montant: "2000 FCFA",
        statut: "Délivrée",
        payment: "Wave",
    },
    {
        id: 7,
        utilisateur: "ama@gmail.com",
        date: "Mardi 23 Juin 2025",
        montant: "2000 FCFA",
        statut: "Délivrée",
        payment: "Wave",
    },
];
